import { type AnalyticsEventsMap } from "@/libs/telemetry"
import { type Detections } from "./detector"

export function getAngleDeviationEventContent({
  isYaw,
  detections,
}: {
  isYaw: boolean
  detections: Detections | null
}): AnalyticsEventsMap["face_angle_deviation"]["event_content"] | null {
  if (!detections?.face) return null

  const { pitch, yaw } = detections.face.rotation

  if (isYaw) return yaw > 0 ? "horizontal_deviation_left" : "horizontal_deviation_right"

  return pitch > 0 ? "vertical_deviation_down" : "vertical_deviation_up"
}
